import "./guestDetails.scss";
import React, { useEffect, useMemo, useState } from "react";
import { MenuItem, TextField, Button, Paper } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { genderOptions } from "../../Constants/Constants";
import countries_List from "../../Constants/country_list.json";
import AllServices from "../../Services/AllServices";
import { toast } from "react-toastify";
import CustomLoader from "../../components/CustomLoader/CustomLoader";
import "@fontsource/roboto";
import "@fontsource/roboto/700.css";
import CancelTwoToneIcon from "@mui/icons-material/CancelTwoTone";

const AddGuestDetails = () => {
  const [form, setForm] = useState([]);

  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState("");
  const navigation = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [open, setOpen] = useState(false);

  const responseString = queryParams.get("response");

  // const response = responseString
  // ? JSON.parse(decodeURIComponent(responseString))
  // : null;
  const response = JSON.parse(responseString);

  const formData = location.state?.formData;

  let BookingReferenceNum =
    response?.referenceNumber || response?.Refference_Number;
  let ContactNumber = response?.contact_Num || response?.Contact_Number;

  //calculte how many card wants
  let NumberOfAdults = parseInt(
    response?.num_Of_Adults || response?.Num_Of_Adults,
  );
  let NumberOfKids = parseInt(response?.num_Of_Kids || response?.Num_Of_Kids);

  if (Number.isNaN(NumberOfKids)) {
    NumberOfKids = 0;
  }

  let TotalCount = parseInt(NumberOfAdults + NumberOfKids);

  const [guest, setGuest] = useState([
    {
      firstName: "",
      lastName: "",
      gender: "",
      dob: "",
      contact: "",
      documents: [],
      contact: "",
      email: "",
    },
  ]);

  useEffect(() => {
    if (TotalCount > 0) {
      const initialGuests = Array.from({ length: TotalCount }, () => ({
        firstName: "",
        lastName: "",
        gender: "",
        dob: "",
        contact: "",
        documents: [],
        email: "",
      }));
      setGuest(initialGuests);
    }
  }, [TotalCount]);

  useEffect(() => {
    if (response) {
      setGuest((prevGuests) => {
        const updatedGuests = [...prevGuests];
        updatedGuests[0] = {
          ...updatedGuests[0],
          firstName: response?.customer_Fname || response?.Customer_Fname,
          lastName: response?.customer_Lname || response?.Customer_Lname,
          contact: ContactNumber,
        };
        return updatedGuests;
      });
    }

    const fetchAndSetGuest = async () => {
      setLoading(true);
      try {
        const response =
          await AllServices.getOwnDetailsById(BookingReferenceNum);

        const data = response.data.message;
        const children = data?.childrens || [];
        const files = data?.files || [];
        setGuest((prevGuests) => {
          setForm(data);

          const updatedGuests = [...prevGuests];

          const guestMainFiles = files.filter((file) =>
            file.Fieldname.startsWith("guests[0][documents]"),
          );

          updatedGuests[0] = {
            ...updatedGuests[0],
            gender: data?.Gender || "",
            dob: data?.DOB || "",
            email: data?.email || "",
            documents: guestMainFiles,
          };

          children.forEach((child, index) => {
            const guestIndex = index + 1;

            // const childDocs = files.filter(
            //   (f) => f.Fieldname === `guests[${guestIndex}]`
            // );
            const childDocs = files.filter((f) =>
              f.Fieldname.startsWith(`guests[${guestIndex}][documents]`),
            );

            updatedGuests[guestIndex] = {
              ...updatedGuests[guestIndex],
              firstName: child.Fname || "",
              lastName: child.Lname || "",
              gender: child.Gender || "",
              dob: child.DOB || "",
              contact: child.ContactNumber || "",
              email: child.email || "",
              documents: childDocs,
            };
          });

          return updatedGuests;
        });
      } catch (error) {
        toast.error("There is an error fetching your details");
      } finally {
        setLoading(false);
      }
    };

    fetchAndSetGuest();
  }, []);

  const [errors, setErrors] = useState([
    {
      firstName: false,
      lastName: false,
      gender: false,
      dob: false,
      contact: false,
      documents: false,
      email: false,
    },
  ]);

  const validateGuests = () => {
    let isValid = true;

    const newErrors = guest.map((card, index) => {
      const cardErrors = {};

      Object.entries(card).forEach(([key, value]) => {
        if (key === "contact" || key === "email") {
          if (index !== 0) {
            cardErrors[key] = false;
          } else {
            cardErrors[key] = !value || value.toString().trim() === "";
            if (cardErrors[key]) isValid = false;
          }
        } else if (key === "documents") {
          cardErrors[key] = value.length === 0;
          if (cardErrors[key]) isValid = false;
        } else if (key === "dob") {
          cardErrors[key] = !value || value.toString().trim() === "";
          if (cardErrors[key]) isValid = false;
        } else if (key === "gender") {
          cardErrors[key] = !value || value.toString().trim() === "";
          if (cardErrors[key]) isValid = false;
        } else if (key === "firstName") {
          cardErrors[key] = !value || value.toString().trim() === "";
          if (cardErrors[key]) isValid = false;
        } else if (key === "lastName") {
          cardErrors[key] = !value || value.toString().trim() === "";
          if (cardErrors[key]) isValid = false;
        }
      });

      return cardErrors;
    });

    setErrors(newErrors);
    return isValid;
  };

  const handleInputChange = (index, e) => {
    const { name, value } = e.target;

    const updatedList = [...guest];
    updatedList[index][name] = value;
    setGuest(updatedList);
  };

  const handleDateChange = (index, newValue) => {
    const updatedList = [...guest];
    updatedList[index].dob = newValue ? newValue.format("YYYY-MM-DD") : "";
    setGuest(updatedList);
  };

  // const handleFileChange = (index, e) => {
  //   const files = Array.from(e.target.files).slice(0, 2);
  //   setGuest((prevGuests) =>
  //     prevGuests.map((guest, i) =>
  //       i === index ? { ...guest, documents: files } : guest
  //     )
  //   );
  // };

  const handleFileChange = (index, e) => {
    const files = Array.from(e.target.files);
    const currentDocuments = guest[index]?.documents || [];

    // Calculate available slots
    const availableSlots = 2 - currentDocuments.length;

    if (availableSlots <= 0) {
      // Already have 2 documents, don't add more
      e.target.value = ""; // Reset input
      return;
    }

    // Take only as many files as we have available slots
    const filesToAdd = files.slice(0, availableSlots);

    if (filesToAdd.length > 0) {
      setGuest((prevGuests) =>
        prevGuests.map((guest, i) =>
          i === index
            ? {
                ...guest,
                documents: [...currentDocuments, ...filesToAdd], // Append, not replace
              }
            : guest,
        ),
      );
    }

    // Reset input to allow selecting files again
    e.target.value = "";
  };

  const handleRemoveFile = (guestIndex) => {
    setGuest((prevGuests) =>
      prevGuests.map((guest, index) =>
        index === guestIndex ? { ...guest, documents: [] } : guest,
      ),
    );
  };

  const handleSubmit = async () => {
    if (validateGuests()) {
      const formData = new FormData();

      guest.forEach((g, index) => {
        formData.append(`guests[${index}][firstName]`, g.firstName);
        formData.append(`guests[${index}][lastName]`, g.lastName);
        formData.append(`guests[${index}][gender]`, g.gender);
        formData.append(`guests[${index}][dob]`, g.dob);
        formData.append(`guests[${index}][contact]`, g.contact);
        formData.append(`guests[${index}][email]`, g.email);
        g.documents.slice(0, 2).forEach((file, fileIndex) => {
          formData.append(
            `guests[${index}][documents][${fileIndex + 1}]`,
            file,
          );
        });
      });
      formData.append("bookingReference", BookingReferenceNum);
      formData.append("ContactNumber", ContactNumber);
      setLoading(true);

      try {
        const response = await AllServices.createCustomer(formData);

        if (response.data.succuss === true) {
          toast.success(response.data.message);
          navigation("/endpage");
        }
      } catch (error) {
        toast.error("Submission failed");
        setLoading(false);
      } finally {
        setLoading(false);
      }
    } else {
      toast.error("Every fields should filled!");
    }
  };

  const getFilteredCountries = (query) => {
    if (!query) return [];
    return countries_List
      .filter((c) => c.country.toLowerCase().startsWith(query.toLowerCase()))
      .slice(0, 20);
  };

  return (
    <div className="guestDetails">
      {loading && (
        <div className="loader-overlay">
          <CustomLoader />
        </div>
      )}
      
      <div className="top-section">
        <h1 className="heading" style={{ fontFamily: "Roboto" }}>
          Guest Registration
        </h1>
        <div className="divider" />
        <p className="subtitle" style={{ fontFamily: "Roboto" }}>
          Please complete the registration by entering details and uploading identification documents for all guests.
        </p>
      </div>

      {guest.map((form, index) => (
        <div key={index} className="formList-card">
          <div className="guest-card-header">
            <span
              className={index < NumberOfAdults ? "adult-header" : "kid-header"}
              style={{ fontFamily: "Roboto" }}
            >
              {index < NumberOfAdults ? `Guest ${index + 1} (Adult)` : `Guest ${index + 1} (Child)`}
            </span>
          </div>
          
          <div className="inputs">
            <div className="inputs-top">
              <div className="inputs-Left">
                <TextField
                  className="textField"
                  id={`outlined-basic-fname-${index}`}
                  name="firstName"
                  type="text"
                  label="First name"
                  required
                  variant="outlined"
                  value={guest[index].firstName}
                  onChange={(e) => handleInputChange(index, e)}
                  sx={{
                    backgroundColor:
                      index === 0 ? "rgba(0, 82, 151, 0.05)" : "transparent",
                    "& .MuiInputBase-input.Mui-disabled": {
                      cursor: "not-allowed",
                    },
                    "& .MuiInputBase-root.Mui-disabled": {
                      cursor: "not-allowed",
                    },
                  }}
                  // disabled={index === 0}
                  error={errors[index]?.firstName}
                  helperText={
                    errors[index]?.firstName ? "First name is required" : ""
                  }
                />

                <TextField
                  className="textField"
                  id={`outlined-basic-lname-${index}`}
                  name="lastName"
                  type="text"
                  label="Last name"
                  required
                  variant="outlined"
                  value={guest[index].lastName || ""}
                  onChange={(e) => handleInputChange(index, e)}
                  sx={{
                    backgroundColor:
                      index === 0 ? "rgba(0, 82, 151, 0.05)" : "transparent",
                    "& .MuiInputBase-input.Mui-disabled": {
                      cursor: "not-allowed",
                    },
                    "& .MuiInputBase-root.Mui-disabled": {
                      cursor: "not-allowed",
                    },
                  }}
                  // disabled={index === 0}
                  error={errors[index]?.lastName}
                  helperText={
                    errors[index]?.lastName ? "Last name is required" : ""
                  }
                />

                {index === 0 && (
                  <TextField
                    className="textField"
                    id="outlined-basic-contact"
                    name="contact"
                    type="text"
                    label="Contact Number"
                    required
                    variant="outlined"
                    value={guest[index].contact || ""}
                    onChange={(e) => handleInputChange(index, e)}
                    error={errors[index]?.contact}
                    sx={{
                      backgroundColor: "rgba(0, 82, 151, 0.05)",
                      "& .MuiInputBase-input.Mui-disabled": {
                        cursor: "not-allowed",
                      },
                      "& .MuiInputBase-root.Mui-disabled": {
                        cursor: "not-allowed",
                      },
                    }}
                    disabled={index === 0}
                    helperText={
                      errors[index]?.contact ? "Contact number is required" : ""
                    }
                  />
                )}
              </div>
              
              <div className="inputs-Right">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Date of Birth"
                    value={guest[index].dob ? dayjs(guest[index].dob) : null}
                    maxDate={dayjs()}
                    format="YYYY-MM-DD"
                    onChange={(newValue) => handleDateChange(index, newValue)}
                    inputFormat="DD/MM/YYYY"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        slotProps={{
                          htmlInput: { ...params.inputProps, readOnly: true },
                        }}
                        required
                        className="textField"
                        name="dob"
                        id={`outlined-basic-dob-${index}`}
                        error={errors[index]?.dob}
                        helperText={
                          errors[index]?.dob ? "Birth day is required" : ""
                        }
                      />
                    )}
                  />
                </LocalizationProvider>

                {index === 0 && (
                  <TextField
                    className="textField"
                    id="outlined-basic-email"
                    name="email"
                    type="text"
                    label="E-mail"
                    required
                    variant="outlined"
                    value={guest[index].email || ""}
                    onChange={(e) => handleInputChange(index, e)}
                    error={errors[index]?.email}
                    helperText={
                      errors[index]?.email ? "E-mail is required" : ""
                    }
                  />
                )}

                <TextField
                  className="textField"
                  id={`outlined-basic-gender-${index}`}
                  name="gender"
                  select
                  label="Gender"
                  required
                  variant="outlined"
                  value={guest[index].gender || ""}
                  onChange={(e) => handleInputChange(index, e)}
                  error={errors[index]?.gender}
                  helperText={errors[index]?.gender ? "Gender is required" : ""}
                >
                  {genderOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
            </div>
            
            <div className="middle" style={{ fontFamily: "Roboto" }}>
              <div className="file-upload-btn-wrapper">
                <input
                  style={{ display: "none" }}
                  id={`upload-file-${index}`}
                  type="file"
                  multiple
                  accept=".jpg,.jpeg,.png,.pdf"
                  onChange={(e) => handleFileChange(index, e)}
                />
                <label htmlFor={`upload-file-${index}`}>
                  <Button
                    variant="contained"
                    component="span"
                    className="upload-btn"
                    disabled={guest[index]?.documents?.length >= 2}
                  >
                    Upload Passport / NIC (PDF / Images)
                    {guest[index]?.documents?.length > 0 &&
                      ` (${guest[index].documents.length}/2)`}
                  </Button>
                </label>

                {errors[index]?.documents && (
                  <p
                    style={{ color: "#ef4444", fontSize: "0.75rem", marginTop: 8, fontWeight: 500, textAlign: "left" }}
                  >
                    Please upload at least one document (max 2)
                  </p>
                )}

                {guest[index]?.documents?.length > 0 && (
                  <div className="uploaded-docs-list">
                    <div className="list-header">
                      <span>Uploaded Documents</span>
                      <span className="remove-all" onClick={() => handleRemoveFile(index)}>Clear All</span>
                    </div>
                    {guest[index].documents.map((file, fileIndex) => (
                      <div className="doc-item" key={fileIndex}>
                        <span className="doc-name">
                          {file.name ||
                            file.FileName?.split("-")[1] ||
                            `Document ${fileIndex + 1}`}
                        </span>
                        <CancelTwoToneIcon
                          className="remove-doc-btn"
                          onClick={() => {
                            // Since handleRemoveFile clears all, we'll keep it simple or allow individual item clearing if needed
                            // For consistency with existing state:
                            handleRemoveFile(index);
                          }}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}

      <div className="submitBtn">
        <button
          className="submit-button"
          onClick={handleSubmit}
          style={{ fontFamily: "Roboto" }}
        >
          Submit All Details
        </button>
      </div>
    </div>
  );
};

export default AddGuestDetails;
